module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [(!this.$props.isPastRun) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(_vm.race.name) + " with " + _vm._s(_vm.trainer.firstName) + " " + _vm._s(_vm.trainer.lastName) + ".\n          "), (_vm.isAutoPilotRace) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: _vm.autopilotTooltip,
        placement: 'bottom'
      }),
      expression: "{content: autopilotTooltip, placement: 'bottom'}"
    }],
    staticClass: "autopilot-pill"
  }, [_vm._v("AUTOPILOT")]) : _vm._e(), _vm._v(" "), (_vm.isAutoPilotRace) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'You can use this button to start the auto run process manually',
        placement: 'bottom'
      }),
      expression: "{content: 'You can use this button to start the auto run process manually', placement: 'bottom'}"
    }],
    staticClass: "auto-start-button",
    on: {
      "click": _vm.startAutoRun
    }
  }, [_vm._v("START NOW")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(" Start " + _vm._s(_vm.time) + "   " + _vm._s(_vm.date(_vm.race.date)))]), _vm._v(" "), (!_vm.raceStarted) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("To start  " + _vm._s(_vm.minutesLeft) + "\"" + _vm._s(_vm.secondsLeft))]) : _vm._e(), _vm._v(" "), (_vm.channel) ? _c('div', {
    staticClass: "steaming-url"
  }, [_c('span', [_vm._v("Channel : ")]), _vm._v(" " + _vm._s(_vm.channel) + "\n          "), (_vm.race.rsvp_limit) ? _c('span', {
    staticClass: "rsvp_limit"
  }, [_vm._v("RSVP Limit : ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.race.rsvp_limit) + "\n        ")]) : _c('div', {
    staticClass: "steaming-url"
  }, [_c('span', [_vm._v("No Channel Found")])]), _vm._v(" "), (_vm.currentChannel) ? _c('div', {
    staticClass: "channelInfo"
  }, [_c('div', [_vm._v(_vm._s(_vm.currentChannel.id))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.pwd))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.desc))])]) : _vm._e()])]), _vm._v(" "), (Object.keys(_vm.race).length >= 0) ? _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    attrs: {
      "id": "app-buttons"
    }
  }, [_c('button', {
    staticClass: "btn  btn--primary notification-button",
    attrs: {
      "disabled": _vm.isStartLive
    },
    on: {
      "click": function($event) {
        _vm.openNotification(_vm.race.id)
      }
    }
  }, [_vm._v("Notification\n        ")]), _vm._v(" "), (_vm.isQuestion) ? _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "Standby",
      "disabled": _vm.CurrentRaceStatus != 2
    },
    on: {
      "click": _vm.standBy
    }
  }, [_vm._v("StandBy\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isQuestion) ? _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "Standby",
      "disabled": _vm.CurrentRaceStatus != 2
    },
    on: {
      "click": function($event) {
        _vm.showQuestionModalNow(true)
      }
    }
  }, [_vm._v("StandBy\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "live-button",
      "disabled": _vm.CurrentRaceStatus != 3
    },
    on: {
      "click": _vm.startLive
    }
  }, [_vm._v("Start\n          Live\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "StartRun",
      "disabled": _vm.CurrentRaceStatus != 4
    },
    on: {
      "click": _vm.startRace
    }
  }, [_vm._v("Start Run\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "FinishRun",
      "disabled": _vm.CurrentRaceStatus != 5
    },
    on: {
      "click": _vm.finishRace
    }
  }, [_vm._v("Finish\n          Run\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "finish-live-button",
      "disabled": _vm.CurrentRaceStatus != 6
    },
    on: {
      "click": _vm.finishLive
    }
  }, [_vm._v("\n          Finish Live\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "question flex",
    attrs: {
      "id": "questionWrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftcolumn"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.todayQuestion.question) + "\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#108ee9"
    },
    attrs: {
      "id": "rightcolumn"
    }
  }, [(!_vm.isQuestion) ? _c('a', {
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": function($event) {
        _vm.showQuestionModalNow(false)
      }
    }
  }, [_vm._v("Add Question")]) : _vm._e(), _vm._v(" "), (_vm.isQuestion && _vm.isStandBy) ? _c('a', {
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": function($event) {
        _vm.showQuestionModalNow(false)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "headertimers"
  }, [_c('remaining-time')], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$props.isPastRun) ? _c('router-link', {
    attrs: {
      "to": "/admin/past-run"
    }
  }, [_vm._v("↩ Back")]) : _vm._e(), _vm._v(" "), (this.$props.isPastRun) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "large",
      "padding": "14px 10px 0px 0px"
    }
  }, [_vm._v("Recording:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-width": "300px"
    }
  }, [_c('audio', {
    attrs: {
      "id": "my-audio",
      "controls": ""
    },
    on: {
      "ended": _vm.playEnd
    }
  }, [_c('source', {
    attrs: {
      "src": ("https://liverun-bucket.s3.amazonaws.com/spreaker-live/live-" + (this.$route.params.raceId) + ".mp3"),
      "type": "audio/mp3"
    }
  })])]), _vm._v(" "), (this.$props.isPastRun) ? _c('button', {
    staticClass: "btn btn--primary loadData",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "loaddatafb"
    },
    on: {
      "click": function($event) {
        _vm.fromServer()
      }
    }
  }, [_vm._v(" Load From Server\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentChannel && this.$props.isPastRun) ? _c('div', {
    staticClass: "channelInfo"
  }, [_c('div', [_vm._v("Channel : " + _vm._s(_vm.channel))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.id))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.pwd))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.desc))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (this.$props.isPastRun) ? _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "question",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftcolumn"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.todayQuestion.question) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#108ee9"
    },
    attrs: {
      "id": "rightcolumn"
    }
  }, [(!_vm.isQuestion) ? _c('a', {
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": function($event) {
        _vm.showQuestionModalNow(false)
      }
    }
  }, [_vm._v("Add Question")]) : _vm._e(), _vm._v(" "), (_vm.isQuestion && _vm.isStandBy) ? _c('a', {
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": function($event) {
        _vm.showQuestionModalNow(false)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('sweet-modal', {
    ref: "quoteOfDay"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "https://contattafiles.s3-us-west-1.amazonaws.com/tnt8888/hIf7gIIFd6jb9AY/q.png",
      "alt": "Question"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Today's Quote")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.availableQuote),
      expression: "availableQuote"
    }],
    attrs: {
      "id": "Quote",
      "name": "quote",
      "Placeholder": "Enter Quote Here"
    },
    domProps: {
      "value": (_vm.availableQuote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.availableQuote = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [(!_vm.isQuoteOfDayExist) ? _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "disabled": _vm.isClicked
    },
    on: {
      "click": function($event) {
        _vm.SaveQuoteOfDay()
      }
    }
  }, [_vm._v("\n        Save\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isQuoteOfDayExist) ? _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "disabled": _vm.isClicked
    },
    on: {
      "click": function($event) {
        _vm.SaveQuoteOfDay()
      }
    }
  }, [_vm._v("\n        Update\n      ")]) : _vm._e()])]), _vm._v(" "), _c('sweet-modal', {
    ref: "existingQuote",
    on: {
      "close": _vm.onSelectNo
    }
  }, [_c('p', [_vm._v("A quote already exists for this date: "), (_vm.existingTodayQuote) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.existingTodayQuote.quote))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("Would you like to update this?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    on: {
      "click": function($event) {
        _vm.onSelectYes()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    on: {
      "click": function($event) {
        _vm.onSelectNo()
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])]), _vm._v(" "), (_vm.raceIdToNotification) ? _c('modal-one-signal', {
    attrs: {
      "race-id": _vm.raceIdToNotification
    },
    on: {
      "close-modal": _vm.closeOneSignal
    }
  }) : _vm._e(), _vm._v(" "), _c('race-question', {
    attrs: {
      "show": _vm.showQuestionModal,
      "raceId": _vm.raceId,
      "todayQuestion": _vm.todayQuestion
    },
    on: {
      "saved": _vm.onSavedQuestion
    }
  }), _vm._v(" "), _c('quote', {
    attrs: {
      "show": _vm.showQuoteModal,
      "todayQuote": _vm.todayQuote,
      "isQuoteExist": _vm.isQuoteExist,
      "date": _vm.sdate
    },
    on: {
      "saved": _vm.onSavedQuote,
      "tapped": _vm.test
    }
  }), _vm._v(" "), (_vm.tapped) ? _c('date-picker', {
    ref: "modal",
    attrs: {
      "date": _vm.sdate,
      "showActionButtons": false
    },
    on: {
      "change": _vm.onChangeDate
    },
    model: {
      value: (_vm.sdate),
      callback: function($$v) {
        _vm.sdate = $$v
      },
      expression: "sdate"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e33cd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/Header.vue
// module id = 1812
// module chunks = 1